import { ApiClient, apiClient } from "../../../core/api_client";
import { generateCrudRepoFactory } from "../../../core/crud";
import { ICRUDRepo } from "../../../core/models";
import { ITransaction, ITransactionForm, transactionFromJson, transactionToJson } from "./entities";

interface ITransactionRepo extends ICRUDRepo<ITransaction, ITransactionForm> {}

const URL = "v1/transaction";

const TransactionRepoImplFactory = (apiClient: ApiClient): ITransactionRepo => {
  const r: ITransactionRepo = {
    ...generateCrudRepoFactory<ITransaction, ITransactionForm>(apiClient, URL, transactionFromJson, transactionToJson),
  };

  return r;
};

export const TransactionRepoImpl = TransactionRepoImplFactory(apiClient);
